<template>
    <header class="tw-bg-[#F1F7FE] tw-py-4 md:tw-py-7 tw-px-4" v-if="!isCustom">
        <div class="tw-max-w-5xl tw-mx-auto tw-relative">
            <div v-if="!isFromApp" class="2xl:tw-absolute 2xl:tw-top-0 2xl:-tw-left-28 tw-mb-3 md:tw-mb-6 2xl:tw-mb-0">
                <button class="tw-bg-[rgba(0,12,23,0.40)] hover:tw-bg-[rgba(0,12,23,0.80)] tw-py-1 tw-px-2.5 tw-text-white tw-rounded-full" @click="handleGoBack">
                    <i class="fa-solid fa-chevron-left"></i>
                </button>
            </div>
            <div class="md:tw-flex tw-items-center tw-gap-6 tw-mb-12 tw-text-center md:tw-text-left">
                <div class="md:tw-flex-1">
                    <!--  Header logo  -->
                    <img class="tw-h-20 sm:tw-h-20 lg:tw-h-28 tw-mb-2 tw-inline-block " alt="header logo" :src="`https://www.musora.com/cdn-cgi/image/width=440,quality=95/${ cohort['light_mode_logo'] }`" />
                    <!--  Headline  -->
                    <h1 class="tw-font-extrabold tw-text-3xl lg:tw-text-4xl">{{ cohort['headline'] }}</h1>
                    <!--  Subheadline  -->
                    <h2 class="tw-font-normal tw-text-2xl lg:tw-text-3xl">{{ cohort['subheadline'] }}</h2>
                    <!--  Header description  -->
                    <p class="tw-font-bold tw-mt-4 lg:tw-mt-6 tw-mb-2">{{ cohort['header_description'] }}</p>
                    <!-- Benefits -->
                    <div class="tw-mb-7 lg:tw-mb-9 tw-flex tw-justify-between sm:tw-justify-center md:tw-justify-start tw-max-w-md sm:tw-max-w-none tw-mx-auto">
                        <div class="md:tw-flex sm:tw-mr-4 md:tw-mr-2">
                            <i :class="`fas fa-check tw-text-${brand} tw-mt-1 tw-mr-1`" aria-hidden="true"></i><br class="md:tw-hidden"> <span class="tw-text-sm">{{ cohort['benefit_1'] }}</span>
                        </div>
                        <div class="md:tw-flex sm:tw-mr-4 md:tw-mr-2 tw-px-2 sm:tw-px-0">
                            <i :class="`fas fa-check tw-text-${brand} tw-mt-1 tw-mr-1`" aria-hidden="true"></i><br class="md:tw-hidden"> <span class="tw-text-sm">{{ cohort['benefit_2'] }}</span>
                        </div>
                        <div class="md:tw-flex">
                            <i :class="`fas fa-check tw-text-${brand} tw-mt-1 tw-mr-1`" aria-hidden="true"></i><br class="md:tw-hidden"> <span class="tw-text-sm">{{ cohort['benefit_3'] }}</span>
                        </div>
                    </div>
                    <!--  Mobile Header Image -->
                    <div class="tw-relative md:tw-hidden">
                        <img
                            class="tw-rounded-xl tw-mb-6"
                            :src="`https://www.musora.com/cdn-cgi/image/width=850,quality=95/${cohort['header_image_url']}`"
                            alt="header thumb"
                        />
                        <div v-if="cohort['cohort_trailer']" class="tw-absolute tw-bottom-4 tw-left-4 tw-bg-white tw-rounded-full tw-uppercase tw-font-bebas-neue tw-px-5 tw-py-1 tw-flex tw-items-center tw-cursor-pointer" @click="openTrailer = true">
                            <i class="fas fa-play tw-mr-2" aria-hidden="true"></i> <div class="tw-mt-1">Watch Trailer</div>
                        </div>
                    </div>
                    <div class="tw-flex tw-flex-col md:tw-flex-row" :class="isEnrolled ? 'md:tw-items-start' : 'md:tw-items-center'">
                        <!-- Button Section -->
                        <div class="tw-w-full md:tw-w-1/2 tw-mb-5 md:tw-mb-0">
                            <button v-if="showGetNotified && !isNotified"
                                    :class="`tw-btn-primary tw-bg-${brand} tw-w-full hover:tw-bg-${brand}-600 sm:tw-max-w-[350px] tw-text-center`" @click="handleGetNotified">
                                <i class="fa-solid fa-calendar tw-mr-2"></i>
                                Get Notified
                            </button>
                            <span v-else-if="showGetNotified && isNotified"
                                  class="tw-btn-primary tw-bg-[#65656B] tw-w-full tw-block tw-text-center">
                                Notification requested!
                            </span>

                            <div v-else-if="isEnrolled" class="tw-text-center">
                                <span class="tw-btn-primary tw-bg-[#65656B] tw-w-full tw-block tw-mb-2 tw-text-white tw-cursor-default sm:tw-max-w-[350px]">
                                    YOU'RE ENROLLED!
                                </span>
                                <a :href="cohort['course_url']"
                                   class="tw-text-[#65656B] tw-underline tw-italic tw-text-sm tw-inline-block tw-mb-2 md:tw-mb-0">
                                    View the course now!
                                </a>
                            </div>

                            <div v-else class="tw-flex tw-flex-col tw-w-full tw-items-center">
                                <button v-if="showEnrollNow"
                                        :class="`tw-btn-primary tw-bg-${brand} tw-text-center tw-w-full sm:tw-max-w-[350px] tw-text-white tw-mb-2 md:tw-mb-0 hover:tw-bg-${brand}-600`"
                                        @click="cohort['is_product'] ? scrollToBottom() : enroll()">
                                    Enroll Now
                                </button>
                                <p v-if="isSolo && !isEnrolled && !cohort['is_product'] && showEnrollNow"
                                   @click="handleNoGuide"
                                   class="tw-text-black tw-italic tw-uppercase tw-font-black tw-text-[14px] tw-underline tw-pt-2 tw-cursor-pointer">
                                    UNLOCK ALL LESSONS
                                </p>
                                <span v-else-if="showClosed"
                                      class="tw-btn-primary tw-bg-[#65656B] tw-w-full tw-block sm:tw-max-w-[350px] tw-text-center">
                                    Enrollment Closed
                                </span>
                            </div>
                        </div>
                        <div class="md:tw-w-1/2 tw-flex tw-items-center tw-justify-center md:tw-justify-start" :class="{ 'md:tw-mt-2': isEnrolled}">
                            <img
                                class="tw-h-8 md:tw-h-6 tw-mr-1"
                                src="https://www.musora.com/cdn-cgi/image/width=100,quality=95/https://d2vyvo0tyx8ig5.cloudfront.net/products/new-piano-players/joined_profiles.png"
                                alt="joined student profiles"
                            />
                            <p class="tw-text-xs tw-align-middle tw-max-w-[180px] md:tw-max-w-full tw-text-left">
                                Join {{ nPackOwners }} {{ joinText }}
                                who have already registered.
                            </p>
                        </div>
                    </div>
                </div>
                <!--  Tablet/Desktop Header Image  -->
                <div class="md:tw-flex-1 tw-hidden md:tw-block tw-relative">
                    <img
                        class="tw-rounded-xl"
                        :src="`https://www.musora.com/cdn-cgi/image/width=850,quality=95/${cohort['header_image_url']}`"
                        alt="header thumb"
                    />
                    <div v-if="cohort['cohort_trailer']" class="tw-absolute tw-bottom-4 tw-left-4 tw-bg-white tw-rounded-full tw-uppercase tw-font-bebas-neue tw-px-5 tw-py-1 tw-flex tw-items-center tw-cursor-pointer" @click="openTrailer = true">
                        <i class="fas fa-play tw-mr-2" aria-hidden="true"></i> <div class="tw-mt-1">Watch Trailer</div>
                    </div>
                </div>
            </div>
            <div v-if="!isSolo" class="tw-flex tw-flex-wrap sm:tw-flex-nowrap tw-text-center tw-border tw-rounded-lg tw-border-gray-300 tw-mb-2 lg:tw-mb-4">
                <div class="tw-w-full sm:tw-w-auto tw-border-b sm:tw-border-b-0 sm:tw-border-r tw-border-gray-300 tw-py-4 sm:tw-py-3 lg:tw-py-4">
                    <p class="tw-tracking-wide tw-opacity-70 tw-text-sm">STARTS ON</p>
                    <h4 class="tw-px-3 lg:tw-px-5"><strong>{{ startDateText }}</strong></h4>
                    <hr class="tw-border-gray-300 tw-my-4 sm:tw-my-2 lg:tw-my-4">
                    <p class="tw-text-sm tw-px-3 lg:tw-px-5">
                        <!-- Countdown -->
                        <template v-if="countdownText">
                            Enrollment closes in <span class="tw-text-pianote">{{ countdownText }}</span>
                        </template>
                        <template v-else>
                            <span class="tw-text-pianote">Enrollment closed</span>
                        </template>
                    </p>
                </div>
                <!--  Icons/Title/Copies  -->
                <div class="tw-flex tw-items-center sm:tw-justify-center sm:tw-flex-grow">
                    <div class="tw-flex tw-flex-wrap tw-justify-evenly tw-w-full sm:tw-w-auto tw-py-4 sm:tw-py-3 lg:tw-py-4 tw-text-left sm:tw-text-center">
                        <div class="tw-flex sm:tw-flex-col sm:tw-flex-1 tw-w-full sm:tw-w-1/3 tw-px-4 sm:tw-px-3 tw-mb-4 sm:tw-mb-0">
                            <div class="tw-text-center">
                                <i :class="`far fa-fw fa-calendar-day tw-mr-3 sm:tw-mr-0 tw-text-${brand} tw-text-3xl sm:tw-mb-1`" aria-hidden="true"></i>
                            </div>
                            <!--                            <img-->
                            <!--                                class="tw-mr-3 tw-h-[30px] sm:tw-mb-1 sm:tw-mx-auto"-->
                            <!--                                alt="icon 1"-->
                            <!--                                src="https://www.musora.com/cdn-cgi/image/width=60,quality=95/{{ $cohort['icon1_url'] }}"-->
                            <!--                                loading="lazy"-->
                            <!--                                onload="this.classList.remove('tw-opacity-0')"-->
                            <!--                            />-->
                            <p class="tw-leading-tight tw-mx-0">
                                <strong class="tw-font-black">{{ cohort['icon1_title'] }}</strong><br>
                                <span class="tw-text-sm">{{ cohort['icon1_copy'] }}</span>
                            </p>
                        </div>
                        <div class="tw-flex sm:tw-flex-col sm:tw-flex-1 tw-w-full sm:tw-w-1/3 tw-px-4 sm:tw-px-3 tw-mb-4 sm:tw-mb-0">
                            <div class="tw-text-center">
                                <i :class="`far fa-fw fa-clock tw-mr-3 sm:tw-mr-0 tw-text-${brand} tw-text-3xl sm:tw-mb-1`" aria-hidden="true"></i>
                            </div>
                            <!--                            <img-->
                            <!--                                class="tw-mr-3 tw-h-[30px] sm:tw-mb-1 sm:tw-mx-auto"-->
                            <!--                                alt="icon 2"-->
                            <!--                                src="https://www.musora.com/cdn-cgi/image/width=60,quality=95/{{ $cohort['icon2_url'] }}"-->
                            <!--                                loading="lazy"-->
                            <!--                                onload="this.classList.remove('tw-opacity-0')"-->
                            <!--                            />-->
                            <p class="tw-leading-tight tw-mx-0"><strong class="tw-font-black">
                                {{ cohort['icon2_title'] }}</strong><br>
                                <span class="tw-text-sm">{{ cohort['icon2_copy'] }}</span>
                            </p>
                        </div>
                        <div class="tw-flex sm:tw-flex-col sm:tw-flex-1 tw-w-full sm:tw-w-1/3 tw-px-4 sm:tw-px-3">
                            <div class="tw-text-center">
                                <i :class="`far fa-fw fa-trophy tw-mr-3 sm:tw-mr-0 tw-text-${brand} tw-text-3xl sm:tw-mb-1`" aria-hidden="true"></i>
                            </div>
                            <!--                            <img-->
                            <!--                                class="tw-mr-3 tw-h-[30px] sm:tw-mb-1 sm:tw-mx-auto"-->
                            <!--                                alt="icon 3"-->
                            <!--                                src="https://www.musora.com/cdn-cgi/image/width=60,quality=95/{{ $cohort['icon3_url'] }}"-->
                            <!--                                loading="lazy"-->
                            <!--                                onload="this.classList.remove('tw-opacity-0')"-->
                            <!--                            />-->
                            <p class="tw-leading-tight tw-mx-0">
                                <strong class="tw-font-black">{{ cohort['icon3_title'] }}</strong><br>
                                <span class="tw-text-sm">{{ cohort['icon3_copy'] }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>

    <section class="tw-bg-white tw-py-7" v-if="!isCustom">
        <div class="tw-max-w-5xl tw-mx-auto tw-px-4 md:tw-px-10">
            <!--  Body title  -->
            <h3 class="tw-font-extrabold tw-text-center tw-mb-7">{{ cohort['body_title'] }}</h3>
            <!--  Body top description  -->
            <p class="md:tw-px-10" v-html="cohort['body_top_description']"></p>
        </div>
    </section>

    <section class="tw-bg-[#F1F7FE] tw-py-7 " v-if="!isCustom">
        <div class="tw-max-w-5xl tw-mx-auto tw-px-4 md:tw-px-10">
            <div class="tw-relative tw-cursor-pointer tw-mb-10" @click="playTrailer">
                <!--  Body Image  -->
                <img
                    class="tw-rounded-xl tw-transition-opacity tw-opacity-0"
                    :src="`https://www.musora.com/cdn-cgi/image/width=1200,quality=95/${cohort['body_image_url']}`"
                    alt="video thumb"
                    loading="lazy"
                    onload="this.classList.remove('tw-opacity-0')"
                />
            </div>
            <!--  Body logo  -->
            <img
                v-if="cohort['body_logo']"
                class="tw-h-10 sm:tw-h-16 tw-mb-8 tw-mx-auto tw-transition-opacity tw-opacity-0"
                alt="just play logo"
                :src="`https://www.musora.com/cdn-cgi/image/width=1220,quality=95/${cohort['body_logo']}`"
                loading="lazy"
                onload="this.classList.remove('tw-opacity-0')"
            />
            <!--  Body bottom description  -->
            <p class="tw-text-center tw-px-6" v-html="cohort['body_bottom_description']"></p>
        </div>
    </section>


    <!-- <section id="final" v-if="cohort['is_product'] && !isCustom" :class="`tw-bg-${brand} tw-py-20 lg:tw-py-32`">
        <div class="tw-max-w-6xl tw-mx-auto tw-flex tw-flex-col lg:tw-flex-row tw-items-center tw-px-4 lg:tw-px-0">
            <div class="tw-w-full lg:tw-w-1/2 lg:tw-order-1 tw-mb-4 lg:tw-mb-0">
                <div class="tw-w-full tw-aspect-video tw-bg-black tw-rounded-xl tw-overflow-hidden tw-relative">
                    <img :src="`https://www.musora.com/cdn-cgi/image/width=600,quality=95/${cohort['product_image']}`" class="tw-transition-opacity tw-opacity-0 tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0 tw-object-cover" onload="this.classList.remove('tw-opacity-0')" alt="Promo offer"/>
                </div>
            </div>
            <div class="lg:tw-w-1/2 lg:tw-pr-4 tw-text-white tw-text-center md:tw-text-left">
                <h1 class="tw-text-2xl tw-font-extrabold tw-leading-tight tw-mb-5">{{ cohort['product_description_header'] }}</h1>
                <p class="tw-text-base tw-mb-6" v-html="cohort['product_description_body']"></p>
                <div class="tw-mb-5 tw-text-4xl">
                    <s class="tw-text-[rgba(255,255,255,0.7)]">${{ cohort['product_original_price'] }}</s> <span class="tw-font-extrabold">${{ cohort['product_sale_price'] }}</span> Save {{ Math.round(100 - (100 * (cohort['product_sale_price'] / cohort['product_original_price']))) }}%
                </div>
                <span v-if="isEnrolled" class="tw-btn-primary tw-bg-[#65656B] tw-text-white tw-cursor-default">You're enrolled</span>
                <template v-else>
                    <button
                        v-if="!hasEnded"
                        :class="`tw-btn-primary tw-bg-white tw-text-${brand} hover:tw-opacity-80`"
                        @click="enroll(true)"
                    >
                        Enroll + Get the deal
                    </button>
                    <span v-else class="tw-btn-primary tw-bg-[#65656B] tw-text-white tw-cursor-default">Enrollment Closed</span>
                </template>
            </div>
        </div>
    </section> -->

    <section v-if="!isCustom && timelineSections.length > 0" class="tw-text-center tw-px-5 sm:tw-px-6 tw-py-10 sm:tw-py-14 lg:tw-py-20 tw-bg-white">
        <div class="tw-max-w-5xl tw-mx-auto tw-px-4 md:tw-px-10">
        <h2 class="tw-leading-tight tw-mb-4">
            <strong>{{ cohort.feature_headline }}</strong>
        </h2>
        <h6 class="tw-leading-tight tw-mt-3 tw-mb-7 sm:tw-mb-12">
            {{ cohort.feature_subheader }}
        </h6>

        <div class="tw-relative">
            <!-- Timeline Line -->
            <div class="tw-absolute tw-left-1 md:tw-left-1/2 tw-top-0 tw-bottom-0 tw-transform md:tw--translate-x-1/2">
            <div class="tw-h-full tw-w-[2px]" :class="`tw-bg-${brand}`"></div>
            </div>

            <div class="tw-relative">
            <div
                v-for="(section, index) in timelineSections"
                :key="index"
                class="tw-mb-16 md:tw-mb-24 last:tw-mb-0 tw-relative"
            >
            <div 
                :class="`tw-absolute tw-left-0 md:tw-left-1/2 tw-w-3 tw-h-3 tw-rounded-full 
                        tw-transform md:tw--translate-x-1/2 tw-z-10 tw-bg-${brand}`"
                ></div>

                <div class="tw-relative tw-ml-12 md:tw-ml-0 tw-mt-10">
                <div 
                    class="md:tw-grid md:tw-grid-cols-2 sm:tw-gap-20 tw-items-center"
                >
                    <div 
                    class="tw-mt-4 md:tw-mt-0 tw-order-1"
                    :class="{ 'md:tw-order-2': index % 2 !== 0 }"
                    >
                    <div class="tw-relative tw-rounded-lg tw-overflow-hidden">
                        <img
                        v-if="section.img"
                        class="tw-w-full tw-h-full tw-object-cover tw-transition-opacity tw-duration-300 tw-opacity-0"
                        loading="lazy"
                        :src="`https://www.musora.com/cdn-cgi/image/width=1200,quality=95/${encodeURIComponent(section.img)}`"
                        :alt="section.title"
                        @load="$event.target.classList.remove('tw-opacity-0')"
                        />
                    </div>
                    </div>

                    <div 
                    class="tw-mt-2 md:tw-mt-0 tw-text-left tw-order-2"
                    :class="{ 'md:tw-order-1': index % 2 !== 0 }"
                    >
                    <div class="tw-space-y-3">
                        <div v-html="section.text"></div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>
    </section>

    <section class="tw-text-center tw-px-5 sm:tw-px-6 tw-py-10 sm:tw-py-14 lg:tw-py-20 tw-bg-[#f4f8fb]" v-if="!isCustom && cohort['enrollment_coach_bio'] && cohort['enrollment_coach_image']">
        <div class="tw-max-w-5xl tw-mx-auto tw-px-4 md:tw-px-10">
            <div class="tw-flex tw-flex-wrap sm:tw-flex-nowrap tw-items-start tw-justify-center sm:tw-mt-8">
                <div class="tw-w-52 sm:tw-w-72 lg:tw-w-80 tw-relative -tw-mb-8 sm:tw-mb-0 sm:tw-mt-12 sm:-tw-mr-8">
                    <img class="tw-inline-block sm:tw-hidden tw-w-full tw-relative tw-z-20 tw-transition-opacity tw-opacity-0"
                         :src="`https://www.musora.com/cdn-cgi/image/width=850,quality=95/${cohort['enrollment_coach_image']}`"
                         :alt="cohort['instructor']"
                         loading="lazy"
                         onload="this.classList.remove('tw-opacity-0')">
                    
                    <img class="tw-hidden sm:tw-inline-block tw-absolute tw-top-0 tw-left-0 tw-w-full tw-z-20 tw-transition-all tw-opacity-0"
                         :src="`https://www.musora.com/cdn-cgi/image/width=850,quality=95/${cohort['enrollment_coach_image']}`"
                         loading="lazy"
                         onload="this.classList.remove('tw-opacity-0')">
                    
                    <img class="tw-absolute tw-top-0 tw-left-1/2 tw-max-w-none tw-z-10 tw-transition-all tw-opacity-0"
                         style="width: 130%; transform: translate(-44%, -7%);"
                         src="https://dpwjbsxqtam5n.cloudfront.net/drum-shop/30-day-chops/coach-brush-layer.png"
                         alt="profile picture"
                         loading="lazy"
                         onload="this.classList.remove('tw-opacity-0')">
                </div>
                
                <div class="tw-text-white tw-text-left tw-z-10 tw-rounded-xl tw-pt-14 tw-pb-8 sm:tw-py-10 lg:tw-py-12 tw-px-6 sm:tw-pr-10 sm:tw-pl-14 lg:tw-px-24 tw-max-w-lg lg:tw-max-w-2xl sm:tw-mt-8 tw-w-full sm:tw-w-auto sm:tw-flex-grow"
                     style="background-color:#00101d;">
                    <h6 :class="`tw-uppercase tw-text-${brand} tw-leading-normal tw-text-center sm:tw-text-left`">MEET YOUR TEACHER</h6>
                    <h2 class="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-mb-4 sm:tw-mb-6 lg:tw-mb-8">
                        <strong>{{ cohort['instructor'] }}</strong>
                    </h2>
                    <div v-html="cohort['enrollment_coach_bio']"></div>
                </div>
            </div>
        </div>
    </section>

    <section class="tw-bg-white tw-py-10">
        <div class="tw-max-w-4xl tw-mx-auto tw-pl-6 tw-pr-4">
            <div v-if="!isSolo && !cohort['is_product']" class="tw-text-center">
                <!--  Logo  -->
                <img class="tw-h-20 sm:tw-h-28 lg:tw-h-28 tw-mb-4 tw-inline-block " alt="header logo" :src="`https://www.musora.com/cdn-cgi/image/width=440,quality=95/${ cohort['light_mode_logo'] }`" />
                <!--  Bottom title  -->
                <h3 class="tw-font-extrabold ">{{ cohort['bottom_title'] }}</h3>
                <p class="uppercase tw-mt-4"
                    :class="`tw-text-${brand}`">
                    <!-- Countdown -->
                    <template v-if="countdownText">
                        Enrollment closes in <span class="tw-font-black">{{ countdownText }}</span>
                    </template>
                    <template v-else>
                        <span class="tw-text-pianote">Enrollment closed</span>
                    </template>
                </p>
                <!--  Bottom description  -->
                <p class="tw-font-bold tw-mt-4 tw-mb-6">{{ cohort['bottom_description'] }}</p>
            </div>

            <template v-if="cohort['is_product'] && !isSolo">
                    <h1 class="tw-font-extrabold tw-text-center tw-px-4 lg:tw-px-28 tw-leading-tight">
                        {{ cohort['product_description_header'] }}
                    </h1>
                    <p class="tw-text-center tw-mt-3 tw-mb-7 lg:tw-mb-10 tw-px-4 lg:tw-px-10">
                        {{ cohort['product_description_body'] }}
                    </p>

                    <div v-if="!isEnrolled && !hasEnded" ref="bottomSection">
                        <div class="md:tw-flex md:tw-justify-center md:tw-gap-4 tw-px-4 md:tw-px-0 tw-mb-4 tw-space-y-4 md:tw-space-y-0">

                            <!-- Course Only Card -->
                            <div class="tw-w-full tw-max-w-[340px] tw-rounded-2xl tw-bg-white tw-border-2 tw-border-[#2A2F34] tw-text-center tw-mx-auto md:tw-mx-0 tw-relative tw-flex tw-flex-col tw-h-full">
                                <div class="tw-flex tw-justify-center tw-absolute tw-left-0 -tw-top-2 tw-w-full">
                                    <div class="tw-uppercase tw-bg-[#2A2F34] tw-px-5 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-semibold tw-text-white">
                                        Course Only
                                    </div>
                                </div>
                                <div class="tw-px-5 md:tw-px-6 tw-py-8 md:tw-py-10 tw-flex tw-flex-col tw-h-full">
                                    <h2 class="tw-text-2xl tw-font-extrabold tw-leading-tight tw-mb-2">
                                        {{ cohort['title'] }}
                                    </h2>

                                    <img class="tw-h-28 lg:tw-h-36 tw-mx-auto tw-mb-3"
                                        alt="course thumbnail"
                                        :src="`https://www.musora.com/cdn-cgi/image/width=440,quality=95/${ cohort['light_mode_logo'] }`"
                                    />

                                    <h3 class="tw-leading-tight tw-font-extrabold">
                                            <strong>FREE</strong>
                                    </h3>
                                    <p v-if="cohort['product_original_price'] > cohort['product_sale_price']"
                                        class="tw-text-sm tw-italic">
                                        Included in your membership.
                                    </p>

                                    <div class="tw-my-3">
                                          <!-- Buttons -->
                                        <button v-if="showGetNotified && !isNotified" :class="`tw-btn-primary tw-bg-[#2A2F34] tw-w-full tw-max-w-[230px] hover:tw-bg-[#2A2F34]/60 tw-transition-opacity tw-duration-300`" @click="handleGetNotified">
                                            <i class="fa-solid fa-calendar tw-mr-2 tw-mb-1"></i>
                                            Get Notified
                                        </button>
                                        <span v-else-if="showGetNotified && isNotified" class="tw-btn-primary tw-bg-[#65656B] tw-w-full tw-max-w-[230px] tw-mb-2 md:tw-mb-0">Notification requested!</span>
                                        <button v-else-if="showEnrollNow" id="cardEnrollNow" @click="enroll()"
                                            class="tw-btn-primary tw-bg-[#2A2F34] tw-w-full tw-max-w-[230px] hover:tw-bg-[#2A2F34]/60 tw-transition-opacity tw-duration-300">
                                            Enroll Now
                                        </button>
                                        <span v-else-if="showClosed" class="tw-btn-primary tw-bg-[#65656B] tw-w-full tw-text-white">Enrollment Closed</span>
                                    </div>
                                    <p class="tw-text-center tw-text-xs">{{ cohort['course_description'] }}</p>
                                </div>
                            </div>

                            <!-- Course + Product Card -->
                            <div :class="`tw-w-full tw-max-w-[340px] tw-rounded-2xl tw-bg-white tw-border-2 tw-border-${brand} tw-text-center tw-relative tw-mx-auto md:tw-mx-0 tw-flex tw-flex-col tw-h-full`">
                                <div class="tw-flex tw-justify-center tw-absolute tw-left-0 -tw-top-2 tw-w-full">
                                    <div v-if="cohort['get_product_badge']" :class="`tw-uppercase tw-bg-${brand} tw-px-5 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-semibold tw-text-white`">
                                        {{ cohort['get_product_badge'] }}
                                    </div>
                                </div>

                                <div class="tw-px-5 md:tw-px-6 tw-py-8 md:tw-py-10 tw-flex tw-flex-col tw-h-full">
                                    <h2 class="tw-text-2xl tw-font-extrabold tw-leading-tight tw-mb-2">
                                        {{ cohort['product_name'] }}
                                    </h2>

                                    <img class="tw-h-28 lg:tw-h-36 tw-mx-auto tw-mb-3"
                                        alt="product image"
                                        :src="`https://www.musora.com/cdn-cgi/image/width=440,quality=95/${ cohort['product_image'] }`"
                                    />

                                    <h3 class="tw-leading-tight tw-font-extrabold">
                                        <template v-if="cohort['product_original_price'] > cohort['product_sale_price']">
                                            <s class="tw-text-[#2A2F3480] tw-opacity-50 tw-mr-1">
                                                ${{ cohort['product_original_price'] }}
                                            </s>
                                            <strong>${{ cohort['product_sale_price'] }}</strong>
                                        </template>
                                        <template v-else>
                                            <strong>${{ cohort['product_original_price'] }}</strong>
                                        </template>
                                    </h3>
                                    <p v-if="cohort['product_original_price'] > cohort['product_sale_price']"
                                        class="tw-text-sm tw-italic">
                                        Save {{ Math.round(100 - (100 * (cohort['product_sale_price'] / cohort['product_original_price']))) }}%
                                    </p>
                                        <div class="tw-my-3">
                                            <button @click="handleGetDeal" id="getTheDeal"
                                            :class="`tw-btn-primary tw-bg-${brand} tw-w-full tw-max-w-[230px] hover:tw-bg-${brand}-600 tw-transition-opacity tw-duration-300`">
                                            Get the deal
                                            </button>
                                        </div>
                                    <p class="tw-text-center tw-text-xs">{{ cohort['course_product_description'] }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

            <div v-if="!cohort['is_product']" class="tw-max-w-[415px] md:tw-max-w-xl tw-mx-auto tw-flex tw-flex-col md:tw-flex-row md:tw-gap-2 tw-mb-4 tw-justify-center">
                <!-- Buttons -->
                <button v-if="showGetNotified && !isNotified" :class="`tw-btn-primary tw-bg-${brand} tw-w-full md:tw-w-1/2 tw-text-white tw-mb-2 md:tw-mb-0 hover:tw-bg-${brand}-600`" @click="handleGetNotified">
                    <i class="fa-solid fa-calendar tw-mr-2 tw-mb-1"></i>
                    Get Notified
                </button>
                <span v-else-if="showGetNotified && isNotified" class="tw-btn-primary tw-bg-[#65656B] tw-w-full md:tw-w-1/2 tw-mb-2 md:tw-mb-0 tw-cursor-default">Notification requested!</span>
                <span v-else-if="isEnrolled" class="tw-btn-primary tw-bg-[#65656B] tw-w-full md:tw-w-1/2 tw-mb-2 md:tw-mb-0 tw-cursor-default">YOU'RE ENROLLED!</span>
                <template v-else>
                    <button v-if="showEnrollNow" id="bottomEnrollNow" @click="enroll()" :class="`tw-btn-primary tw-bg-${brand} tw-w-full md:tw-w-1/2 tw-text-white tw-mb-2 md:tw-mb-0 hover:tw-bg-${brand}-600`">Enroll Now</button>
                    <span v-else-if="showClosed" class="tw-btn-primary tw-bg-[#65656B] tw-w-full tw-text-white tw-cursor-default">Enrollment Closed</span>
                </template>
                <a v-if="cohort['conversation_url'] && isEnrolled" x-cloak x-show="isEnrolled" :href="cohort['conversation_url']" class="tw-btn-secondary tw-border-black tw-w-full md:tw-w-1/2 tw-text-black hover:tw-bg-black hover:tw-text-white">Join the conversation</a>
            </div>

            <!-- Cart link -->
            <div v-if="cohort['is_product'] && isEnrolled && !hasEnded" class="tw-text-center tw-mb-3">
                <img class="tw-h-28 lg:tw-h-36 tw-mx-auto tw-mb-6" alt="course thumbnail" :src="`https://www.musora.com/cdn-cgi/image/width=440,quality=95/${ cohort['light_mode_logo'] }`" />
                <a :href="cohort['product_cart_link']" target="_blank" class="tw-text-sm tw-text-[#2563EB] tw-underline">{{ cohort['product_cart_link_description'] }}</a>
            </div>

            <div v-if="isSolo && !isEnrolled.value" class="tw-text-center tw-mb-2">
                <button id="noGuideText" @click="handleNoGuide" class="tw-text-black tw-italic tw-underline tw-font-bold tw-text-sm">UNLOCK ALL LESSONS</button>
            </div>

            <div v-if="!cohort['is_product']" class="tw-max-w-[250px] tw-mx-auto tw-flex tw-justify-center tw-items-center">
                <img class="tw-h-7 sm:tw-mb-1 lg:tw-mb-0 tw-mr-1 tw-transition-opacity tw-opacity-0" src="https://www.musora.com/cdn-cgi/image/width=100,quality=95/https://d2vyvo0tyx8ig5.cloudfront.net/products/new-piano-players/joined_profiles.png" alt="joined student profiles" loading="lazy" onload="this.classList.remove('tw-opacity-0')" />
                <p class="tw-text-xs tw-align-middle">
                    Join {{ nPackOwners }} {{ joinText }}
                    who have already registered.
                </p>
            </div>

            <!--  Dropdown  -->
            <h3 class="tw-font-extrabold tw-text-center tw-mb-7 tw-mt-10">{{ cohort['dropdown_title'] }}</h3>
            <CohortDropdown
                v-if="dropdowns.length > 0"
                v-for="(dropdown, index) in dropdowns"
                :key="`dropdown ${index}`"
                :title="dropdown['title']"
                :desc="dropdown['description']"
            />
        </div>
    </section>

    <!-- Trailer Modal -->
    <VideoModal v-if="openTrailer" :videoUrl="cohort['cohort_trailer']" @onCloseModal="openTrailer = false" />

    <ChallengeNotificationModal
        v-if="openChallengeNotificationModal && !isFromApp"
        :challengeType="challengeType"
        :challenge="{
            ...cohort,
            dark_mode_logo_url: cohort['dark_mode_logo'],
            light_mode_logo_url: cohort['light_mode_logo'],
        }"
        :challenge-type="challengeType"
        @modal-close="closeNotificationModal"
        :is-from-get-deal="isFromGetDeal"
    />
    <ChallengeActionModal v-if="challengeActionModalType && !isFromApp" :modal-type="challengeActionModalType"  @close-modal="closeActionModal"
      :challenge="{
        dark_mode_logo_url: cohort['dark_mode_logo'],
        light_mode_logo_url: cohort['light_mode_logo'],
        id: cohort['id'],
        title: cohort['title'],
        next_lesson: cohort['next_lesson'],
        web_url_path: cohort['course_url'],
        last_completion_date: cohort['last_completion_date'],
      }"
      @post-retake="handlePostRetake"
    />
    <ChallengeGetNotifiedModal v-if="isGetNotifiedModalOpen && !isFromApp" default-step="1" @close-modal="closeGetNotifiedModal"/>
</template>
<script setup>
import { inject, ref, computed, onBeforeMount, onUnmounted } from 'vue';
import { storeToRefs } from "pinia/dist/pinia";
import { useUserStore } from "@stores/user";
import { postChallengesEnroll, postChallengesEnrollmentNotification } from 'musora-content-services';

import CohortDropdown from '@collections/Dropdown/CohortDropdown';
import VideoModal from '@collections/Modal/VideoModal';
import ChallengeNotificationModal from '@collections/Modal/ChallengeNotificationModal';
import ChallengeActionModal from '@collections/Modal/ChallengeActionModal';
import ChallengeGetNotifiedModal from '@collections/Modal/ChallengeGetNotifiedModal';

const userStore = useUserStore();
const { brand } = storeToRefs(userStore);
const isFromGetDeal = ref(false);

const props = defineProps({
    cohort: {
        type: Object,
        default: {},
    },
    dropdowns: {
        type: Array,
        default: [],
    },
    hasProduct: {
        type: Boolean,
        default: false,
    },
    nPackOwners: {
        type: String,
        default: '',
    },
    registerUrl: {
        type: String,
        default: ''
    },
    isCustom: {
        type: Boolean,
        default: false,
    },
})


const token = inject('csrf_token');

const isNotified = ref(props.cohort.is_notified)
const notificationRequested = ref(false);
const isEnrollmentOpen = ref(false);
const isEnrolled = ref(props.hasProduct);
const countdownText = ref('');
const openTrailer = ref(false);
const openPurchase = ref(false);
const hasEnded = ref(false);
const openChallengeNotificationModal = ref(false);
const challengeActionModalType = ref('');
const isFromApp = ref(false);
const isGetNotifiedModalOpen = ref(false);
const bottomSection = ref(null);

const joinText = computed(() => {
    return brand.value === 'drumeo' ? 'drummers' : brand.value === 'pianote' ? 'piano players' : brand.value === 'guitareo' ? 'guitar players' : brand.value === 'singeo' ? 'singers' : 'students'
});

const challengeType = computed(() => {
    if(isSolo.value){
        return 'solo';
    } else {
        return 'community'
    }
})

const isSolo = computed(() => {
    return props.cohort.is_solo;
})

const showEnrollNow = computed(() => {
    //when user is not enrolled for solo challenge
    if(isSolo.value && !isEnrolled.value){
        return true;
    }
    //when user is not enrolled and enrollment is still open for community challenge
    else if(!isSolo.value && !isEnrolled.value && !hasEnded.value){
        return true;
    }

    return false;

})

const showClosed = computed(() => {
    //when community challenge has ended
    if(!isSolo.value && hasEnded.value){
        return true;
    }

    return false;
})

const showGetNotified = computed(() => {
    //when community challenge enrollment is not opened
    if(!isSolo.value && !isEnrollmentOpen.value){
        return true;
    }

    return false;
})

const scrollToBottom = () => {
  const element = bottomSection.value;
  if (element) {
    element.scrollIntoView();
  }
};

const handleGetDeal = () => {
  isFromGetDeal.value = true;
  enroll("purchase");
};

const enroll = async(message = "enroll") => {
    try {
        if(props.cohort.has_completed_challenge && isSolo.value){
            openActionModal('retake');
            sendPostMessage('retake');
        } else {
            const enrollUser = await postChallengesEnroll(props.cohort.id);
            if(enrollUser){
                openChallengeNotificationModal.value = true;
                isEnrolled.value = true;
                sendPostMessage(message);
            } else {
                window.shownotification({
                    icon: 'error',
                    text: 'Woops! Something wrong happened, please try again later.'
                })
            }
        }
    } catch (e){
        window.shownotification({
            icon: 'error',
            text: 'Woops! Something wrong happened, please try again later.'
        })
    }
}

const handlePostRetake = () => {
    isEnrolled.value = true;
    challengeActionModalType.value = '';

    //To reopen the modal container
    setTimeout(() => {
        openChallengeNotificationModal.value = true;
    }, 10)

}

const closeNotificationModal = () => {
    openChallengeNotificationModal.value = false;
}

const handleNoGuide = () => {
    openActionModal('unlock');
    sendPostMessage('guide');
}

const openActionModal = (type) => {
    challengeActionModalType.value = type;
}

const closeActionModal = () => {
    challengeActionModalType.value = '';
}

const formatDate = (date) =>{
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = date.getDate();
    const month = months[date.getMonth()];

    // Determine the day suffix
    const suffix =
        day % 10 === 1 && day !== 11 ? "st" :
        day % 10 === 2 && day !== 12 ? "nd" :
        day % 10 === 3 && day !== 13 ? "rd" :
        "th";

    return `${month} ${day}${suffix}`;
}

const startDateText = computed(() => {
    return formatDate(new Date(props.cohort['cohort_start_date']));
})

const handleGoBack = () => {
    history.back();
}

const sendPostMessage = (type) => {
    if(isFromApp.value){
        window.ReactNativeWebView.postMessage(JSON.stringify({
            type,
            data:props.cohort
        }));
    }
}

const handleGetNotified = async () => {
    const response = await postChallengesEnrollmentNotification(props.cohort.id);
    notificationRequested.value = true;
    isGetNotifiedModalOpen.value = true;
    isNotified.value = true;
    sendPostMessage('notify');
}

const closeGetNotifiedModal = () => {
    isGetNotifiedModalOpen.value = false;
}

const playTrailer = () => {
    if(props.cohort['cohort_trailer']) openTrailer.value = true;
}

const countdown = () => {
    const start = new Date(props.cohort['enrollment_end_time']);
    const now = Date.now();
    const isEnded = now >= start;

    if(!isEnded){
        const diff = start - Date.now();
        // Calculate days, hours, minutes, seconds
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        if(window.innerWidth < 768){
            countdownText.value = `${days > 0 ? `${days}D` : ''} ${hours > 0 ? `${hours}H` : ''} ${minutes > 0 ? `${minutes}M` : ''} ${seconds > 0 ? `${seconds}S` : ''}`;
        } else {
            countdownText.value = `${days > 0 ? `${days} days` : ''} ${hours > 0 ? `${hours} hours` : ''} ${minutes > 0 ? `${minutes} minutes` : ''} ${seconds > 0 ? `${seconds} seconds` : ''}`;
        }
    } else {
        countdownText.value = '';
        hasEnded.value = true;
        clearInterval(countdown);
    }
}

const watchEnrollmentOpen = () => {
    const openDate = new Date(props.cohort['enrollment_start_time']);
    const now = new Date();

    if(openDate <= now){
        isEnrollmentOpen.value = true;
        clearInterval(watchEnrollmentOpen);
    }
}

onBeforeMount(() => {
    const openDate = new Date(props.cohort['enrollment_start_time']);
    const closeDate = new Date(props.cohort['enrollment_end_time']);
    const now = new Date();

    //Start countdown for unclosed community challenges
    if(!isSolo.value && now < closeDate){
        countdown();
        setInterval(countdown, 1000);
    }
    //End enrollment for community challenges
    else if(!isSolo.value && now >= closeDate){
        hasEnded.value = true;
    }

    if(!isSolo.value && openDate <= now){
        watchEnrollmentOpen();
        setInterval(watchEnrollmentOpen, 1000);
    }

    const url = window.location.href;
    if(url.includes('mobile-app-web-view')){
        isFromApp.value = true;
    }
})

onUnmounted(() => {
    clearInterval(countdown);
    clearInterval(watchEnrollmentOpen);
})

const timelineSections = computed(() => {
  return [
    {
      img: props.cohort?.feature1_image || null,
      text: props.cohort?.feature1_text || null,
    },
    {
      img: props.cohort?.feature2_image || null,
      text: props.cohort?.feature2_text || null,
    },
    {
      img: props.cohort?.feature3_image || null,
      text: props.cohort?.feature3_text || null,
    }
  ].filter(section => section.img && section.text);
});

</script>
